import { useContext } from "react";

import { MeetingsContextMenuContext } from "./MeetingsContextMenuContext";

export function useMeetingsContextMenu() {
  const context = useContext(MeetingsContextMenuContext);
  if (!context) {
    throw new Error("useMeetingsContextMenu must be used within a MeetingsContextMenuProvider");
  }
  return context;
}
